<template>
  <div class="position-relative mw-800 mx-auto py-6 px-8">
    <ConfirmAppointmentHeader
      v-if="status"
      :isAdminOrPartner="isAdminOrPartner"
      :address="address"
      :code="code"
      :status="status"
      :appointmentData="appointmentData"
      :isLoading="isLoading"
      :new-appointment-date-info="newAppointmentDateInfo"
    />

    <ConfirmAppointmentMessages
      v-if="status"
      :appointmentData="appointmentData"
      :isLoading="isLoading"
      :status="status"
      :isAdminOrPartner="isAdminOrPartner"
      :is-editing-new-date="!!newAppointmentDateInfo"
    />

    <div class="hide-on-print">
      <ConfirmAppointmentDetails v-if="showDetails" />
      <ConfirmAppointmentForm
        v-if="showForm"
        :key="newAppointmentDateInfo ? newAppointmentDateInfo.date : 'original'"
        :new-appointment-date-info="newAppointmentDateInfo"
        @confirmationSubmitted="setNewAppointmentDateInfo(null)"
      />
    </div>

    <ConfirmAppointmentPrint
      :confirmationSignature="confirmationSignature"
      :confirmationData="confirmationData"
      :isAdminOrPartner="isAdminOrPartner"
      :timezone="appointmentData.timezone"
      :status="status"
    />

    <img :src="poweredBy" :alt="$t('quote.label.poweredByAlt')" class="quote__logo--footer mb-8" />

    <!-- modals -->
    <SelectAvailableDates @setNewAppointmentDateInfo="setNewAppointmentDateInfo" :timezone="appointmentData.timezone" />
    <!-- /modals -->
  </div>
</template>

<script>
import { api } from '@/services'
import { mapGetters, mapActions } from 'vuex'

import { shouldShowConfirmForm } from './confirmAppointment/confirmAppointmentForm.helpers'

import ConfirmAppointmentForm from './confirmAppointment/ConfirmAppointmentForm'
import ConfirmAppointmentDetails from './confirmAppointment/ConfirmAppointmentDetails'
import ConfirmAppointmentMessages from './confirmAppointment/fragments/ConfirmAppointmentMessages'
import ConfirmAppointmentHeader from './confirmAppointment/fragments/ConfirmAppointmentHeader'
import ConfirmAppointmentPrint from './confirmAppointment/ConfirmAppointmentPrint'

// modals
import SelectAvailableDates from './confirmAppointment/modals/SelectAvailableDates'

export default {
  name: 'ConfirmAppointment',

  components: {
    ConfirmAppointmentMessages,
    ConfirmAppointmentDetails,
    ConfirmAppointmentForm,
    ConfirmAppointmentHeader,
    ConfirmAppointmentPrint,
    SelectAvailableDates,
  },

  computed: {
    ...mapGetters(['confirmAppointmentData', 'isLoading', 'appointment']),

    status() {
      return this.confirmAppointmentData?.status
    },

    appointmentData() {
      return this.isAdminOrPartner ? this.appointment : this.confirmAppointmentData
    },

    address() {
      return this.confirmAppointmentData?.meeting_location_description ?? 'no address provided'
    },

    code() {
      return this.confirmAppointmentData?.code ?? 'no code provided'
    },

    confirmationData() {
      return this.appointmentData?.confirmation
    },

    isAdminOrPartner() {
      const userRoles = localStorage.getItem('access_roles')
      if (!userRoles) return false

      const userRolesArray = userRoles?.split(',')
      return userRolesArray.includes('ROLE_ADMIN') || userRolesArray.includes('ROLE_PARTNER')
    },

    showForm() {
      return shouldShowConfirmForm({
        isLoading: this.isLoading,
        isAdminOrPartner: this.isAdminOrPartner,
        confirmation: this.appointmentData.confirmation,
        newAppointmentDateInfo: this.newAppointmentDateInfo,
      })
    },

    showDetails() {
      return !this.isLoading && this.appointmentData.confirmation
    }
  },

  methods: {
    ...mapActions(['fetchConfirmAppointmentData', 'fetchAppointmentAsAdmin', 'showErrorMessage']),

    setNewAppointmentDateInfo(newAppointmentDateInfo) {
      this.newAppointmentDateInfo = newAppointmentDateInfo
    },

    fetchConfirmAppointment() {
      const { id } = this.$route.params

      if (id) this.fetchConfirmAppointmentData(id)

      if (this.isAdminOrPartner) {
        this.fetchAppointmentAsAdmin(id)

        api.get(`/admin/appointmentFiles/confirmationSignatureDownloadUrl/${id}`)
          .then(({ data }) => this.confirmationSignature = data?.url)
          .catch(({ data }) => console.log(data?.message))
      }
    }
  },

  data() {
    return {
      poweredBy: require('@/assets/images/logo-powered-by.svg'),
      confirmationSignature: '',
      newAppointmentDateInfo: null,
    }
  },

  mounted() {
    this.fetchConfirmAppointment()
  },
}
</script>

<style>
.confirm-appointment-first-column {
  border-right: 1px solid #e0e0e0;
}

@media print {
  .hide-on-print {
    display: none;
  }
}
</style>
